import React, { useState } from "react";
import "../styles/InfoPaper.scss";
import ScriptBoxCaller from "../../../../components/ScriptBoxCaller/ScriptBoxCaller";
import { Popover } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import TableLoading from "../../../../components/TableLoading/TableLoading";

const ContainerPaperRelevance = (props) => {
  const {
    types,
    callerIcon,
    callerEvent,
    havePermission,
    isDisabled,
    isPlotLoading,
  } = props;

  const typeKeys = ["plot", "thematic", "universe"];
  const typeLabels = { 0: "Trama", 1: "Temática", 2: "Universo" };

  return types.map((item, i) => {
    const typeKey = typeKeys[i];
    const isPlot = typeKey === "plot";

    return (
      <div className="infoField" key={i}>
        <div className="infoFieldHeader">
          <span className="infoName">{typeLabels[i]}</span>
          {!!callerEvent && havePermission && (
            <ScriptBoxCaller
              callerIcon={callerIcon(typeKey)}
              event={!isDisabled ? () => callerEvent(typeKey) : () => {}}
            />
          )}
        </div>

        <div className="infoDataList">
          {isPlot && isPlotLoading ? (
            <TableLoading />
          ) : (
            <>
              {!!item.primaries.length && (
                <Position items={item?.primaries} position="Principal" />
              )}
              {!!item.secundaries.length && (
                <Position items={item?.secundaries} position="Secundária" />
              )}
              {!!item.tertiaries.length && (
                <Position items={item?.tertiaries} position="Terciária" />
              )}

              {!item?.primaries?.length &&
                !item?.secundaries?.length &&
                !item?.tertiaries?.length && (
                  <div className="infoData emptyData">
                    <span className="emptyText"></span>
                  </div>
                )}
            </>
          )}
        </div>
      </div>
    );
  });
};

const Position = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentGroup, setCurrentGroup] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const { items, position } = props;

  const groupedItems = items.reduce((acc, item) => {
    const grp = acc.find((g) => g.id === item.id);
    if (grp) grp.items.push(item);
    else acc.push({ id: item.id, name: item.name, items: [item] });
    return acc;
  }, []);

  const handleClick = (event, group) => {
    setAnchorEl(event.currentTarget);
    setCurrentGroup(group);
    setCurrentIndex(0);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExited = () => {
    setCurrentGroup(null);
    setCurrentIndex(0);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      {!!groupedItems.length && (
        <div className="infoData">
          <div className="contentData">
            <span className="contentOriginName">{position}</span>
            <div className="descriptions">
              {groupedItems.map((group, index) => (
                <span
                  className="descriptionName"
                  key={index}
                  onClick={(e) => handleClick(e, group)}
                  style={{ cursor: "pointer" }}
                >
                  {group.name}
                  {group.items.length > 1 && ` (${group.items.length})`}
                  {index + 1 < groupedItems.length && (
                    <span className="originSeparator">, </span>
                  )}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        onExited={handleExited}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <div style={{ padding: 16, maxWidth: 500 }}>
          <span style={{ color: "#7f808e" }}>{currentGroup?.name}</span>
          <br />
          <br />

          <span style={{ mb: 3 }}>
            {currentGroup?.items[currentIndex]?.descriptionContext ||
              "Sem descrição"}
          </span>
          <br />

          {currentGroup && currentGroup.items.length > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 4,
              }}
            >
              <span style={{ flex: 1, color: "#7f808e" }}>
                {currentIndex + 1} / {currentGroup.items.length}
              </span>

              <div style={{ display: "flex", gap: 4 }}>
                <ArrowBack
                  fontSize="small"
                  onClick={() => {
                    if (currentIndex > 0) {
                      setCurrentIndex((i) => i - 1);
                    }
                  }}
                  style={{
                    cursor: currentIndex === 0 ? "not-allowed" : "pointer",
                    opacity: currentIndex === 0 ? 0.4 : 1,
                  }}
                />

                <ArrowForward
                  fontSize="small"
                  onClick={() => {
                    if (currentIndex < currentGroup.items.length - 1) {
                      setCurrentIndex((i) => i + 1);
                    }
                  }}
                  style={{
                    cursor:
                      currentIndex === currentGroup.items.length - 1
                        ? "not-allowed"
                        : "pointer",
                    opacity:
                      currentIndex === currentGroup.items.length - 1 ? 0.4 : 1,
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </Popover>
    </>
  );
};

const InfoPaperRelevance = (props) => {
  const {
    paperTitle,
    callerIcon,
    callerEvent,
    plots,
    thematics,
    universes,
    havePermission,
    isDisabled,
    isPlotLoading,
  } = props;

  return (
    <div className="infoPaper">
      <div className="paper">
        <div className="paperTitle">
          <span>{paperTitle}</span>
        </div>
        <div className="infoFieldContainer">
          <ContainerPaperRelevance
            types={[plots, thematics, universes]}
            callerEvent={callerEvent}
            callerIcon={callerIcon}
            havePermission={havePermission}
            isDisabled={isDisabled}
            isPlotLoading={isPlotLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default InfoPaperRelevance;
